import { Col, message, Row } from "antd";
import { useEffect, useState } from "react";
import { GetSelfIndex } from './ajax';
import { RenderHtml3 } from "../components/renderhtml";
import { BottomIfor } from './bottom/bottominfo'
import { ButtonforPh } from './bottom/buttomforph'
export function SelfEdit(props) {
  let id = props.match.params.id * 1
  const [data, setData] = useState({ data: [] })
  const reload = async (id) => {
    let res = await GetSelfIndex(id)
    if (res.code !== 0) {
      message.error(res.message)
      return
    }
    else {
      setData(res.data)
    }
  }
  useEffect(() => {
    reload(id)
  }, [id])
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
        <div className="activitydetailbox">
          <div className="activitytitle" style={{ textAlign: 'center', width: '100%' }}>{data.title}</div>
          <div >
            <div style={{ marginTop: 10 }}><RenderHtml3 flow={1000} state={{ content: data.content }} /></div>
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col sm={24} xs={24} md={24} lg={0} xl={0}>
        <div className="activitydetailboxph">
          <div className="activitytitleph" style={{ textAlign: 'center', width: '100%' }}>{data.title}</div>
          <div style={{ width: '100%' }}>
            <div><RenderHtml3 flow={'100%'} state={{ content: parseStr(data.content) }} /></div>
          </div>
        </div>
        <ButtonforPh />
      </Col>
    </Row>
  )
}

function parseStr(str = '') {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, '')) / 1.7)
    return `font-size:${newValue}`
  })
}